<p-sidebar [(visible)]="visible" position="right" [baseZIndex]="10000" styleClass="user-menu-sidebar" (onHide)="closeSidebar()">

  <!-- User profile header -->
  <div class="um-profile">
    <div class="um-avatar">
      <i class="fa fa-user-circle-o" aria-hidden="true"></i>
    </div>
    @if (sessionService.getSession && userProperty.userSelectedCompany) {
      <div class="um-info">
        <span class="um-name">{{ sessionService.fullName }}</span>
        <span class="um-email">{{ sessionService.email }}</span>
        <span class="um-company-badge">{{ userProperty.userSelectedCompany.name }}</span>
      </div>
    }
  </div>

  <!-- Quick actions row -->
  <div class="um-actions-row">
    <button class="um-action-btn um-action-account" (click)="navigateToAccountSettings()">
      <i class="pi pi-cog" aria-hidden="true"></i>
      <span>{{ "account.my-account" | translate }}</span>
    </button>
    @if (canManageAccountSettings) {
      <button class="um-action-btn" (click)="changePassword()">
        <i class="pi pi-lock" aria-hidden="true"></i>
        <span>{{ "account.changepassword" | translate }}</span>
      </button>
    }
    <button class="um-action-btn um-action-signout" (click)="signOut()">
      <i class="pi pi-sign-out" aria-hidden="true"></i>
      <span>{{ 'app.signOut' | translate }}</span>
    </button>
  </div>

  <!-- Mobile-only: Impersonate actions -->
  @if (appProperty.impersonateIsActive) {
    <div class="um-section">
      <button pButton pRipple [loading]="appComponent.impersonateLoader"
        icon="pi pi-user-minus"
        label="{{ 'account.remove-impersonate' | translate }}"
        class="um-impersonate-btn um-impersonate-remove p-button-sm"
        (click)="appComponent.removeImpersonate(); closeSidebar()">
      </button>
    </div>
  }

  <!-- Mobile-only: OAuth providers -->
  @if (appStateHolder.oauthState.providers.length > 0) {
    <div class="um-section um-oauth-section">
      @for (provider of appStateHolder.oauthState.providers; track provider.provider) {
        <div class="um-oauth-item"
          [class.oauth-active]="appComponent.getOAuthProviderStatus(provider.provider) === 'active'"
          [class.oauth-expiring]="appComponent.getOAuthProviderStatus(provider.provider) === 'expiring'"
          [class.oauth-expired]="appComponent.getOAuthProviderStatus(provider.provider) === 'expired'"
          (click)="appComponent.showOAuthPanel($event, provider.provider)">
          @if (provider.provider === 'Office365' || provider.provider === 'Microsoft') {
            <img src="assets/CustomIcons/microsoftprovider.svg" class="um-oauth-icon" alt="Microsoft" />
            <span class="um-oauth-name">Microsoft</span>
          }
          @if (provider.provider === 'Jira' || provider.provider === 'Atlassian') {
            <img src="assets/CustomIcons/jiraprovider.svg" class="um-oauth-icon" alt="Jira" />
            <span class="um-oauth-name">Jira</span>
          }
          <span class="um-oauth-dot"></span>
        </div>
      }
    </div>
  }

  <!-- Company switcher -->
  <div class="um-companies-label">{{ 'app.selectCompany' | translate }}</div>
  <div class="um-companies">
    @for (company of userProperty.userCompaniesList; track $index) {
      <div class="um-company-row" (click)="appComponent.changeCompany(company)">
        <div class="um-company-icon">
          <i class="fa fa-building-o" aria-hidden="true"></i>
        </div>
        <label class="um-company-name">{{ company.name }}</label>
      </div>
    }
  </div>

</p-sidebar>
